import { ref } from '@vue/composition-api';

export default function useProfileVariables() {
  const loading = ref(false);
  const showWelcome = ref(false);
  const idOrSlug = ref('');

  return {
    loading,
    showWelcome,
    idOrSlug,
  };
}
